import React from 'react';
import styled from 'styled-components';
import { WarningAmber } from '@mui/icons-material';

/**
 * ErrorMessage 컴포넌트 Props
 * @typedef {Object} ErrorMessageProps
 * @property {string} [text='필수 값입니다.'] - 에러 메시지 텍스트
 */

/* 인풋 밑 에러메세지 컴포넌트.
 * text : string; (기본값 '필수 값입니다.')
 */
const ErrorMessage = ({ text = '필수 값입니다.' }) => {
  return (
    <Text>
      <WarningAmber sx={{ fontSize: '0.95em', marginRight: '4px', verticalAlign: 'text-bottom', color: 'currentColor' }} />
      {text}
    </Text>
  );
};

const Text = styled.span`
  display: inline-block;
  padding-left: 10px;
  color: #d32f2f;
  font-size: 0.8em;
  word-spacing: 0.3px;
  letter-spacing: -1px;
`;

export default ErrorMessage;
